export {
  EventDetailSeriesNavButtons,
  EventDetailSeriesNavButtonsFragment,
} from "./EventDetailSeriesNavButtons";
